import { useQuery } from '@tanstack/react-query';
import { statisticsApi } from '@/features/statistics/api';
import { POLL_SLOW } from '@/lib/polling';

export const useStatistics = (windowHours: number) =>
  useQuery({ queryKey: ['statistics', windowHours], queryFn: () => statisticsApi.overview(windowHours), refetchInterval: POLL_SLOW });
